import { useRecoilValue } from "recoil"
import { styled } from "styled-components"
import { langSelector, langState } from "../../../state/langState"
import { B2, Heading2, T4_en, T4_ko } from "../../../style/constant"

const Value = () => {
	const currentLang = useRecoilValue(langState)
	const Text = useRecoilValue(langSelector)
	return(
		<Container>
			<Title currentLang={currentLang}>{Text.value.title}</Title>
			{
				Text.value.content.map(item=> 
					<ValueCard>
						<Img src = {item.imgSrc} alt="valueImg" />
						<Wrapper>
							<ValueTitle>{item.title}</ValueTitle>
							<Desc>{item.desc}</Desc>
						</Wrapper>
					</ValueCard>
				)
			}
		</Container>
	)
}


export default Value

interface Props {
	currentLang:boolean;
  }
  

const Container = styled.section`
	display:flex;
	flex-direction: column;
	align-items: center;
	background-color: #060C17;
`

const Title = styled.h2<Props>`
  margin:100px 0;
 ${props => props.currentLang ? 
	`
	${T4_ko}
	`
	:
	`
	${T4_en}
	`
 }
`

const ValueCard = styled.div`
	width:1200px;
 	margin-bottom:100px;
`


const Wrapper = styled.div`
	margin:0 auto;
`

const Img = styled.img`
	height:621px;
	margin-bottom:5px;
`

const ValueTitle = styled.p`
	${Heading2}
	margin-bottom:5px;
`

const Desc = styled.p`
	${B2}
`